import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { convertToKeyValuePairs, isJsonString } from 'src/app/functions/validation-functions';
import { Item } from 'src/app/models/item';
import { AutoCompleteItem } from 'src/app/models/SelectItems';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { LookUpService } from 'src/app/services/lookup.service';
import { MenuService } from 'src/app/services/menu.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-leads-list',
  templateUrl: './leads-list.component.html',
  styleUrls: ['./leads-list.component.css']
})
export class LeadsListComponent {
  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  canView:boolean = false;
  canEdit:boolean = false;
  canDelete:boolean = false;
  canCreate:boolean = false;
  viewUrl:string="";
  editUrl:string="";
  createUrl:string="";
  deleteUrl:string="";
	menuId:number = 0;
	menuUrl : string = "";
  showViewEditModal:boolean = false;
  leadsForm:FormGroup;
  description:any = [];
  leadsStatusList:any = []; 
  policyStatusList:any = []; 
  agentAssignList:AutoCompleteItem[] = []; 
  isEditPopup:boolean = false;
  distributorList:any = [];
  distributorId:number=0;
  resellerList:any = [];
  resellerId:number = 0 ;
  agentList:any = [];
  agentId:number = 0 ;
  userType = "";
  showLoader:boolean = false;
  constructor(private adminService: AdminService, private router:Router, private menuService:MenuService,private generalService: GeneralService,private fb:FormBuilder, private lookupService : LookUpService) {
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if(obj)
    {     
      this.menuId = parseInt(obj['menuId'])??0;
      this.menuUrl = obj['menuUrl']; 
      this.getPermissions(parseInt(obj['id'])??0);
    }
    this.getLeadDetails();
    this.getPolicyStatus();
    this.loadAgentList();

    this.leadsForm = this.fb.group({
      id: [''],
      name: [''],
      email: [''],
      mobileNumber: [''],
      interestedIn: [''],
      description: [''],
      leadsStatus: [0],
      policyStatus: [0],
      assignedToName: [''],
      assignedToUserId: [0],
      contactedOn: [''],
      productId:[0]
    });
    this.userType = this.generalService.getUserType();
    if(this.userType == '2')
    {
      this.bindDistributorDDL();
    }
    else if(this.userType == '2' || this.userType == '3')
    {
      this.bindResellerDDL();
    }
    else
    {
      this.bindAgentDDL();
    }
  }

  async getLeadDetails() {
    this.showLoader = true;
    const res = await this.adminService.LeadsListing(this.agentId??0);    
    this.showLoader = false;
    if (res != null && res.result) {
      this.graphdata = res.result.data;
      let index=3;
      let sort:string='desc';
      console.log(this.graphdata.sort( (a, b) => {
        if(sort == 'desc')
        {
          if (a[index].toString().toLowerCase() > b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() > a[index].toString().toLowerCase()) {
              return 1;
          }          
        }
        else
        {
          if (a[index].toString().toLowerCase() < b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() < a[index].toString().toLowerCase()) {
              return 1;
          }  
        }
        return index;
      }));
      this.graphHeader = res.result.header;
      this.visibleColumnData =  res.result.header.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
      this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
    }
  }

  async onActionClick(data:any)
  {
    this.isEditPopup = false;
    this.description = [];
    if(data)
    {
      const res = await this.adminService.GetLeadById(data?.id??0);  
      if (res != null && res.result) {      
        this.leadsForm.patchValue(res.result);
        this.getLeadsStatus(this.leadsFormControl['productId'].value??0);
        try {
          if(isJsonString(this.leadsForm.get("description")?.value??"")){
            this.description = convertToKeyValuePairs(JSON.parse(this.leadsForm.get("description")?.value??""));
          }
        } 
        catch (e) {
          
        }
        
      }
      if(data.action=="View")
      {
        this.showViewEditModal = true;
        //this.router.navigateByUrl(this.viewUrl,{ state: { id:data.id, userId:data.id1, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      }
      else if(data.action=="Edit")
      {
        this.isEditPopup = true;
        this.showViewEditModal = true;
        //this.router.navigateByUrl(this.editUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      } 
    }
  }
  
  onCreateBtnClick(data:any)
  {
    this.router.navigateByUrl(this.createUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
  }

  async getPermissions(menuId:number)
  {
    let obj = {uniqueUserId:this.generalService.getUniqueuserid(),menuId:menuId};
    let res = await this.menuService.GetMenuPermissionsByUserId(obj);
    if(res && res.isSuccess)
    {
      if(res.result.userMenus.length > 0)
      {
        res.result.userMenus.forEach((element:any) => {
          if(element.permissionName.toLowerCase() =="create")
          {
            this.canCreate = true;
            this.createUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="edit")
          {
            this.canEdit = true;
            this.editUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="view")
          {
            this.canView = true;
            this.viewUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="delete")
          {
            this.canDelete = true;
            this.deleteUrl = element.menuCommand;
          }
        });
      }      
    }
  }

  get leadsFormControl(){
    return this.leadsForm.controls;
  }

  async getLeadsStatus(productId:number){
    let response = await this.lookupService.GetLeadsStatus(productId); 
    if (response?.isSuccess && response?.result?.length > 0) {
      this.leadsStatusList = response.result;
    }
  }
  
  async getPolicyStatus(){
    let response = await this.lookupService.GetPolicyStatus(); 
    if (response?.isSuccess && response?.result?.length > 0) {
      this.policyStatusList = response.result;
    }
  }

  async loadAgentList(){
    //let res = await this.adminService.AgentDropDown();
    let res =  await this.adminService.AgentDropDownByResellerId(this.resellerId);
    if (res != null && res.result) {
      this.agentAssignList = res.result.map((item:any)=> {return {text:item.name,value:item.userId,id:item.userId,checked:false}});
      let dfd = this.agentAssignList;
      debugger;
    }
  }

  onAgentSelection(event:any){
    this.leadsForm.get("assignedToUserId")?.setValue(event.id);
    this.leadsForm.get("assignedToName")?.setValue(event.text);
    debugger
  }

  async updateLeadDetails(){
    let obj = this.leadsForm.value;
    obj.policyStatus = parseInt(this.leadsForm.value.policyStatus??"0");
    obj.leadsStatus = parseInt(this.leadsForm.value.leadsStatus??"0");
    let res = await this.adminService.UpdateLeadStatus(obj);
    if (res != null && res.result) {      
      if(res?.result?.code == 1){
        this.getLeadDetails();
        this.showViewEditModal=  false;
      }
      swal.fire({
        position: 'center',
        icon: res?.result?.code == 1 ? 'success' : 'error',
        title: res?.result?.message,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
        confirmButtonColor: res.result.code == 1 ? "#0DB561" : "#DF3A4D"
      });
    }
  }

  async bindDistributorDDL()
  {
    const res = await this.adminService.DistributorDropDown().then((response)=> { 
      if (response != null && response.result) {
          this.distributorList = response.result.map((m:any)=>{return {id:m.id,name:m.name}});
          this.distributorList.unshift({id:"0",name:"All"});
          if(this.distributorList.length > 0 ){
            this.distributorId = parseInt(this.distributorList[0].id??"0");
          }
          this.bindResellerDDL();
      }   
    });
  }

  async bindResellerDDL()
  {
    const res = await this.adminService.ResellerDropDownByDistributorId(this.distributorId);  
    if (res != null && res.result) {
        this.resellerList = res.result.map((m:any)=>{return {id:m.id,name:m.name}});
        if(this.distributorId == 0){
          this.resellerList.unshift({id:"0",name:"All"});
        }
        if(this.resellerList.length > 0){
          this.resellerId = parseInt(this.resellerList[0].id??"0");
        }
        this.bindAgentDDL();
    }  
  }
  
  async bindAgentDDL()
  {
    const res = await this.adminService.AgentDropDownByResellerId(this.resellerId);  
    if (res != null && res.result) {
        this.agentList = res.result.map((m:any)=>{return {id:m.id,name:m.name}});
        if(this.resellerId == 0){
          this.agentList.unshift({id:"0",name:"All"});
        }
        if(this.agentList.length > 0){
          this.agentId = parseInt(this.agentList[0].id??"0");
        }
    }  
  }
}
